import * as THREE from 'three';
import constants from '../config/Constants';
import settings from '../config/Settings';
import utils from '../utils';

export function createLight() {
  var pointLight = new THREE.PointLight(0xffffff, 2);
  var lights = new THREE.Group();
  lights.add(pointLight);
  return lights;
}

export function createBackground() {
  const material	= new THREE.MeshBasicMaterial({
    map	: new THREE.TextureLoader().load(settings.imgDir + 'galaxy.jpg'),
    side	: THREE.BackSide
  });
  return utils.createSphere(constants.UNIVERSE_RADIUS, material, 16);
}